import * as React from 'react';
/**
 * This function will try to call requestIdleCallback if available to save performance.
 * No need `getLabel` here since already fetch on `rawLabeledValue`.
 */
export default (values) => {
    const cacheRef = React.useRef({
        valueLabels: new Map()
    });
    return React.useMemo(() => {
        const { valueLabels } = cacheRef.current;
        const valueLabelsCache = new Map();
        const filledValues = values.map(item => {
            var _a;
            const { value } = item;
            const mergedLabel = (_a = item.label) !== null && _a !== void 0 ? _a : valueLabels.get(value);
            // Save in cache
            valueLabelsCache.set(value, mergedLabel);
            return Object.assign(Object.assign({}, item), { label: mergedLabel });
        });
        cacheRef.current.valueLabels = valueLabelsCache;
        return [filledValues];
    }, [values]);
};
